angular.module('unica_invitation_list.invitation_list_services', []);